import { render, staticRenderFns } from "./ClvrFloatingCard.vue?vue&type=template&id=65e8bb34"
import script from "./ClvrFloatingCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClvrFloatingCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ClvrFloatingCard.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports